import React from 'react';
import { v4 as uuid } from 'uuid';
import Event from './Event';
import {
  brazil,
  brazilVenezuela,
  chile,
  colombia,
  peru,
  usa,
  usaVenezuela,
  venezuela,
} from '../../flags';

type TEvent = {
  month: string;
  day: string;
  category: string;
  title?: string;
  description: string;
  speaker: string;
  flag: string;
  key?: string;
  link?: string;
};

const events: TEvent[] = [
  {
    month: 'ABR',
    day: '08',
    category: 'WEBINAR',
    description: '¿Cuándo y por qué una tomografía en odontología?',
    hour: '8:00 PM Hora Venezuela',
    speaker: 'Dr. Hugo Aguayo Olivares',
    flag: peru,
  },
  {
    month: 'JUN',
    day: '08',
    category: 'WEBINAR',
    description:
      'Protección radiológica en odontología desde una perspectiva latinoamericana',
    hour: '8:00 PM Hora Venezuela',
    speaker: 'Dr. Alejandro Hidalgo',
    flag: chile,
  },
  {
    month: 'JUL',
    day: '08',
    category: 'WEBINAR',
    description:
      'Imágenes por Resonancia Magnética en Cabeza y Cuello: Fundamentos, Aplicaciones y Análisis de Casos',
    hour: '8:00 PM Hora Venezuela',
    speaker: 'Dr. Guillermo Concha',
    flag: chile,
  },
  {
    month: 'AGO',
    day: '08',
    category: 'WEBINAR',
    description:
      'Neoplasias Óseas Sistémicas  con manifestaciones en los  maxilares',
    hour: '8:00 PM Hora Venezuela',
    speaker: 'Dr. Wilson Delgado',
    flag: peru,
  },
  {
    month: 'SEP',
    day: '08',
    category: 'WEBINAR',
    description:
      'Actualización avanzada en radiología dento-maxilofacial en niños y adolescentes',
    hour: '8:00 PM Hora Venezuela',
    speaker: 'Dr. Andrés Briner',
    flag: chile,
  },
  {
    month: 'OCT',
    day: '08',
    category: 'WEBINAR',
    description:
      'A importância do olhar diferenciado do Radiologista  em uma interpretação imaginológica de qualidade do Complexo MaxiloFacial',
    hour: '8:00 PM Hora Venezuela',
    speaker: 'Dr. Claudio de Freitas',
    flag: brazil,
  },
  {
    month: 'NOV',
    day: '08',
    category: 'WEBINAR',
    description: 'Tips para escribir un caso clínico',
    hour: '8:00 PM Hora Venezuela',
    speaker: 'Dra. Ana Isabel Ortega Villalobos',
    flag: venezuela,
  },
  {
    month: 'NOV',
    day: '08',
    category: 'WEBINAR',
    description: 'Visión Contemporánea de la Apnea del sueño',
    hour: ' ',
    speaker: 'Dr. Roberto Maciel',
    flag: brazil,
  },
  // {
  //   month: 'NOV',
  //   day: '6,7,8',
  //   category: 'CONGRESO',
  //   description: 'Congreso SVRID',
  //   speaker: '',
  //   flag: venezuela,
  // },
].map((event: TEvent) => {
  event.key = uuid();
  event.link = 'https://eventusvip.com/svrid/';
  if (event.category === 'CONGRESO') {
    // event.link = 'http://localhost:8000/congreso';
    event.link = 'https://svrid.org.ve/congreso';
  }
  return event;
});

function EventList() {
  return (
    <div className="xl:max-w-6xl mb-24 mt-12 mx-auto">
      <div className="w-full flex flex-row flex-wrap px-8">
        <div className="w-full text-gray-900 pr-4 text-justify flex flex-col flex-wrap">
          <h2 className="font-semibold text-3xl mt-4 text-blue-700">
            Reuniones Científicas de la SVRID
          </h2>
          <p className="mt-4 w-full text-lg text-gray-600">
            Las Reuniones Científicas de la Sociedad Venezolana de Radiología e
            Imagenología Dentomaxilofacial serán un espacio on line para conocer
            el estado del arte de nuestra disciplina permitiendo la revisión y
            socialización de conceptos, métodos y técnicas imagenológicas.
          </p>
          <div className="w-flex flex flex-wrap flex-row">
            <a
              href="https://eventusvip.com/svrid/"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-3 text-blue-700 inline-flex items-center mr-4"
            >
              Inscribirse
              <svg
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                className="w-4 h-4 ml-2"
                viewBox="0 0 24 24"
              >
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </a>
          </div>
        </div>
      </div>
      <div className="text-gray-700 body-font">
        <div className="container px-5 py-24 mx-auto">
          <div className="flex flex-wrap -mx-4 -my-8">
            {events.map((event) => (
              <Event key={event.key} {...event} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default EventList;
